import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { APP_SETTINGS } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { HandleError } from '../../core/models/handle-error';
import { AuthService } from '../../core/services/auth/auth.service';
import { SpinnerService } from '../../core/services/spinner/spinner.service';
import { UtilityService } from '../../core/services/utility/utility.service';
import { SearchResultsService } from '../search-results/search-results.service';
import { BulletinService } from '../servicebulletin/bulletin.service';
import { NgIf, NgFor, NgStyle, NgClass, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { SearchFilterPipe } from '../../shared/pipes/search-filter.pipe';
import { SortByFilterPipe } from '../../shared/pipes/sort-by-filter.pipe';
import { FilterResultsPipe } from '../../shared/pipes/filter-results.pipe';
import { LoadMoreItemsPipe } from '../../shared/pipes/load-more-items.pipe';
import { BrandTypePipe } from '../../shared/pipes/brand-type.pipe';

@Component({
    selector: 'app-service-bulletin-home',
    templateUrl: './service-bulletin-home.component.html',
    styleUrls: ['./service-bulletin-home.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        FormsModule,
        NgFor,
        NgStyle,
        RouterLink,
        NgClass,
        NgxPaginationModule,
        DatePipe,
        SearchFilterPipe,
        SortByFilterPipe,
        FilterResultsPipe,
        LoadMoreItemsPipe,
        BrandTypePipe,
    ],
})
export class ServiceBulletinHomeComponent implements OnInit, OnDestroy {

  public screenWidth: number;
  private subscription: ISubscription[];
  public isShowAll = false;
  public isShowNew = true;
  public isShowHistory = false;
  public isShowSaved = true;
  public newDocsCount: number;
  public serviceBulletins: any;
  public allServiceBulletins: any;
  public newServiceBulletins: any;
  public historyServiceBulletins: any;
  public serviceError = 'Loading data. Please wait...';
  // public p;

  // side bar variables
  public mainGroupList = [];
  public bodyTypeList = [];
  public fromYears: number[] = [];
  public toYears: number[] = [];
  private currentYear: number;
  public sortBy = [];
  public inputMainGroup;
  public inputSeriesGroup;
  public inputSeries = '';
  public inputSeriesList = '';
  public inputBody;
  public inputFromYear;
  public inputToYear;
  public inputSortBy;
  public filter = {};
  // public filter = { group: '', series: '', body: '', from: '', to: '' };
  public sliceSize = 5000;
  public firstSliceSize = 200;

  public allDataSize = 0;

  // variables to update sort icons
  isDesc = false;
  column = '';
  direction: number;
  search4bulletins: any = '';

  APP_SETTINGS: any;
  seriesName: string;

  redirectOnFirstVisit: boolean = true;

  public numOfItems = {};
  public seriesToDisplay = 6;

  public expandPbs = {};
  viewPortItems: any;
  errorMessage = '';

  private username: string;
  noContent: boolean;

  page: number = 1;
  isPaginateFlag = false;
  isRRShowColor: boolean = false;

  constructor(
    private changeDetector: ChangeDetectorRef,
    private spinnerService: SpinnerService,
    private utilityService: UtilityService,
    private bulletinService: BulletinService,
    private searchResultsService: SearchResultsService,
    private authService: AuthService,
    private route: ActivatedRoute
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }
  ngOnInit() {

    let pageNum = parseInt(this.route.snapshot.paramMap.get('page'));
    this.page = Number.isNaN(pageNum) ? 1 : pageNum;
    this.APP_SETTINGS = APP_SETTINGS;
    this.search4bulletins = (APP_SETTINGS.currentPage == 'sib') ? this.bulletinService.getFilterData() : '';
    APP_SETTINGS.currentPage = 'sib';
    this.subscription = [];
    this.username = this.authService.getUserName();
    if (APP_SETTINGS.isMOTORRAD === "true") {
      this.mainGroupList = APP_SETTINGS.motorradMainGroupList;
    }
    else {
      this.mainGroupList = APP_SETTINGS.mainGroupList;
    }

    this.sortBy = [
      { key: 'bulletinNumber', value: 'Bulletin Number' },
      { key: 'description', value: 'Bulletin Title' },
      { key: 'series', value: 'Bulletin Series' },
      { key: 'releaseDate', value: 'Date' }
    ];
    this.bodyTypeList = this.initializeBodyTypes();

    this.currentYear = (new Date()).getFullYear();
    for (let year = 1985; year < this.currentYear + 1; year++) {
      this.fromYears.push(year);
      this.toYears.push(year);
    }

    this.serviceBulletins = [];
    this.allServiceBulletins = [];
    this.newServiceBulletins = [];
    this.historyServiceBulletins = [];

    //this.showNew();

    if (APP_SETTINGS.serviceBulletins == 'all') { this.showAll(); }
    if (APP_SETTINGS.serviceBulletins == 'new') { this.showNew(); }
    if (APP_SETTINGS.serviceBulletins == 'history') { this.showHistory(); }
    if (APP_SETTINGS.serviceBulletins == 'saved') { this.showSaved(); }

    if (this.bulletinService.getLeftHandFilterBoolean() == true) {
      this.inputMainGroup = this.bulletinService.getLeftHandFilterMainGroupString();
      this.filter = this.bulletinService.getLeftHandFilterObject();
      this.inputToYear = this.bulletinService.getLeftHandFilterToYear();
      this.inputFromYear = this.bulletinService.getLeftHandFilterFromYear();
      this.inputSeries = this.bulletinService.getLeftHandFilterInputSeries();
      this.bulletinService.saveLeftHandFilterBoolean(false);
      this.applyFilterOnReturn();
    }
  }

  showAll() {
    this.spinnerService.show('bmwSpinner');
    this.isShowAll = true;
    this.isShowNew = false;
    this.isShowHistory = false;
    this.isShowSaved = false;
    this.errorMessage = '';
    this.inputSeries = undefined;
    this.inputSeriesGroup = undefined;
    this.noContent = false;
    APP_SETTINGS.serviceBulletins = 'all';
    // if (this.allServiceBulletins.length === 0) {
    // setTimeout(() => {
    //   this.spinnerService.hide('bmwSpinner');
    // }, 2000);

    if (sessionStorage.getItem('serviceBulletinsStorageAll')) {
      let data = JSON.parse(sessionStorage.getItem('serviceBulletinsStorageAll'));
      this.allServiceBulletins = data['content'];
      this.allDataSize = this.allServiceBulletins.length;
      this.serviceBulletins = this.allServiceBulletins.slice(0, 5000);
      this.filterSeries(data['content']);
      this.newDocsCount = data['newSize'];
      this.changeDetector.detectChanges();
      this.spinnerService.hide('bmwSpinner');
    } else {
      this.subscription.push(this.bulletinService.getAllBulletinService().subscribe(data => {
        this.allServiceBulletins = data['content'];
        this.allDataSize = this.allServiceBulletins.length;
        this.serviceBulletins = this.allServiceBulletins.slice(0, 5000);
        this.newDocsCount = data['newSize'];
        this.filterSeries(data['content']);
        sessionStorage.setItem('serviceBulletinsStorageAll', JSON.stringify(data));
        this.changeDetector.detectChanges();
        this.spinnerService.hide('bmwSpinner');
      },
        error => {
          this.spinnerService.hide('bmwSpinner');
          this.serviceError = HandleError.handleAPIError(error);
        }
      ));
    }
  }

  async buildBiggerSlice() {
    setTimeout(() => {
      this.serviceBulletins = this.allServiceBulletins.slice(1000, 2000);
    },
      20000);
  }

  showMore() {
    // this.serviceBulletins = this.serviceBulletins + this.allServiceBulletins.slice(200, 400);
  }

  showNew() {
    this.isShowAll = false;
    this.isShowNew = true;
    this.isShowHistory = false;
    this.isShowSaved = false;
    this.errorMessage = '';
    this.inputSeries = undefined;
    this.inputSeriesGroup = undefined;
    this.noContent = false;
    APP_SETTINGS.serviceBulletins = 'new';

    this.spinnerService.show('bmwSpinner');
    this.subscription.push(this.bulletinService.getNewBulletinService().subscribe(data => {
      this.newServiceBulletins = data['content'];

      this.serviceBulletins = this.newServiceBulletins;
      this.newDocsCount = data['newSize'];
      this.filterSeries(this.newServiceBulletins);
      if (this.newDocsCount === 0) {
        this.errorMessage = 'No New Service Bulletins';
        this.noContent = true;
        if (this.redirectOnFirstVisit === true) {
          this.redirectOnFirstVisit = false;
          // this.showAll();
        }
      }
      this.changeDetector.detectChanges();
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
    //} else {
    //  this.serviceBulletins = this.newServiceBulletins;
    //}
  }
  showHistory() {
    this.isShowAll = false;
    this.isShowNew = false;
    this.isShowHistory = true;
    this.isShowSaved = false;
    this.inputSeries = undefined;
    this.inputSeriesGroup = undefined;
    this.errorMessage = '';
    this.noContent = false;
    APP_SETTINGS.serviceBulletins = 'history';
    // if (this.historyServiceBulletins.length === 0) {
    this.spinnerService.show('bmwSpinner');
    if (sessionStorage.getItem('serviceBulletinsStorageHistory')) {
      let data = JSON.parse(sessionStorage.getItem('serviceBulletinsStorageHistory'));
      this.historyServiceBulletins = data;
      this.filterSeries(this.historyServiceBulletins);
      this.serviceBulletins = this.historyServiceBulletins;
      if (this.serviceBulletins.length === 0) {
        this.errorMessage = 'No History Found';
        this.noContent = true;
      }
      this.changeDetector.detectChanges();
      this.spinnerService.hide('bmwSpinner');
    } else {
      this.subscription.push(this.bulletinService.getHistoryBulletinService(this.username).subscribe(data => {
        this.historyServiceBulletins = data;
        this.filterSeries(this.historyServiceBulletins);
        this.serviceBulletins = this.historyServiceBulletins;
        sessionStorage.setItem('serviceBulletinsStorageHistory', JSON.stringify(data));
        if (this.serviceBulletins.length === 0) {
          this.errorMessage = 'No History Found';
          this.noContent = true;
        }
        this.changeDetector.detectChanges();
        this.spinnerService.hide('bmwSpinner');
      },
        error => {
          this.spinnerService.hide('bmwSpinner');
          this.serviceError = HandleError.handleAPIError(error);
        }
      ));
    }
    //} else {
    //  this.serviceBulletins = this.historyServiceBulletins;
    //}
  }
  showSaved() {
    this.isShowAll = false;
    this.isShowNew = false;
    this.isShowHistory = false;
    this.isShowSaved = true;
    if (APP_SETTINGS.isRollsRoyce === "true") {
      this.isRRShowColor = true;
    }
    this.errorMessage = '';
    this.noContent = true;
    APP_SETTINGS.serviceBulletins = 'saved';
    this.spinnerService.show('bmwSpinner');
    this.subscription.push(this.bulletinService.getUserSavedServieBulletins(this.username).subscribe(data => {
      this.serviceBulletins = data;
      this.filterSeries(this.serviceBulletins);
      if (this.serviceBulletins.length === 0) {
        this.errorMessage = 'No Saved Service Bulletins';
      }
      this.changeDetector.detectChanges();
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
  }
  addBulletinToHistory(isSaved, id) {
    this.bulletinService.saveFilterData(this.search4bulletins);
    this.bulletinService.saveLeftHandFilterBoolean(true);
    this.bulletinService.saveLeftHandFilterObject(this.filter, this.inputMainGroup, this.inputSeries, this.inputFromYear, this.inputToYear);
    if (!isSaved) {
      // this.subscription.push(this.bulletinService.addBulletinToUserHistory(this.username, id).subscribe());
    }
  }
  sortByProperty(propertyParam) {
    this.isDesc = !this.isDesc; // change the direction    
    this.column = propertyParam;
    this.direction = this.isDesc ? 1 : -1;
  }
  updateBodyValues() {
    if (this.inputSeries.trim() !== '') {
      this.subscription.push(this.searchResultsService.getSeriesToBody().subscribe(value => {
        const bulletinWithUserInputSeries = value.find(item => item.seriesName === this.inputSeries.trim().toUpperCase());
        this.bodyTypeList = bulletinWithUserInputSeries ? bulletinWithUserInputSeries.bodies : this.initializeBodyTypes();
      }));
    } else {
      this.bodyTypeList = this.initializeBodyTypes();
    }
  }

  filterSeries(series: string[]) {
    let seriesArray = [];
    series.forEach(element => {
      if (element.hasOwnProperty('series')) {
        let tempSeries = element['series'];
        if (tempSeries.length > 0) {

          for (let i = 0; i < tempSeries.length; i++) {
            seriesArray.push(tempSeries[i].seriesName);
          }
        }
      }
    });
    let uniqueSeries = seriesArray.filter(function (item, index) {
      return seriesArray.indexOf(item) >= index;
    });
    this.inputSeriesGroup = uniqueSeries.sort();
  }

  createFilter() {
    let mainGroupCode = '';
    if (this.inputMainGroup) {
      const matchString = this.inputMainGroup.match(/\[(.*?)\]/)[1];
      if (APP_SETTINGS.isMOTORRAD === 'true') {
        mainGroupCode = matchString;
      } else {
        mainGroupCode = +matchString < 10 ? '0' + matchString : matchString;
      }
    }
    this.inputSeries = this.inputSeries != undefined ? this.inputSeries.trim() : '';
    this.filter = {
      group: mainGroupCode.toString(),
      series: this.inputSeries,
      body: this.inputBody,
      from: this.inputFromYear,
      to: this.inputToYear
    };
  }

  applyFilterOnReturn() {
    if (this.inputSortBy && this.inputSortBy.length > 0) {
      this.sortByProperty(this.inputSortBy);
    }
  }

  applyFilter() {
    this.createFilter();
    if (this.inputSortBy && this.inputSortBy.length > 0) {
      this.sortByProperty(this.inputSortBy);
    } else {
      this.isDesc = true;
      this.sortByProperty('bulletinIdForSort');
    }
  }
  clearFilter() {
    this.inputMainGroup = this.inputBody = this.inputSortBy = this.inputSeries = undefined;
    this.inputFromYear = this.inputToYear = '';
    this.filter = { group: '', series: '', body: '', from: '', to: '' };
    this.bulletinService.saveLeftHandFilterBoolean(false);
  }
  initializeBodyTypes() {
    return [
      { id: 0, name: 'Compact' },
      { id: 1, name: 'Convertible' },
      { id: 2, name: 'GT' },
      { id: 3, name: 'HatchBack' },
      { id: 4, name: 'SAV' },
      { id: 5, name: 'Sedan' },
      { id: 6, name: 'Sports Wagon' },
      { id: 7, name: 'Touring' },
      { id: 8, name: 'Wagon' },
      { id: 9, name: 'Coupe' },
      { id: 10, name: 'Roadster' }
    ];
  }
  pageNumChange(event) {
    this.page = event;
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
  }

  disablePagination() {
    this.isPaginateFlag = true;
  }
  ngOnDestroy(): void {
    this.subscription.forEach(s => s.unsubscribe());
  }

  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }
}
